<template>
  <article v-if="sections" class="st-article">
    <section :class="section.class" v-for="(section, i) in sections" :key="i">
      <div v-for="(comp,count) in filterComponents(section.components)" :key="comp.type+'+'+count"
        :class="componentClass(comp)" :style="componentStyle(comp)">
          <div :class="componentContentClass(comp)" :style="componentContentStyle(comp)">
            <div class="component-anchors" v-if="comp.id" :id="comp.id"></div>
            <component :is="comp.type.toLowerCase()" :attributes="comp"></component>
          </div>
        </div>
    </section>
    <st-credits v-if="credits" :credits="credits" :lang="lang"></st-credits>
    <st-related v-if="relatedarticles" :relatedarticles="relatedarticles"></st-related>

    <section v-if="fbcomment" class="content-fb-comments">
      <div class="fb-comments" :data-href="url()" data-width="100%" data-numposts="5" data-colorscheme="light"></div>
    </section>
  </article>
</template>

<script>
import {mapState} from 'vuex'

import StCredits from './st-credits.vue'
import StRelated from './st-related.vue'
import artefactsMixin from '../artefacts/mixin'

export default {
  computed: mapState(['sections', 'relatedarticles', 'credits', 'fbcomment', 'lang']),
  components: {StCredits, StRelated},
  mixins: [artefactsMixin],
  methods: {
    filterComponents (components) {
      return components.filter(comp => this.existComponent(comp.type))
    },
    componentStyle (comp) {
      return {
        backgroundColor: comp.bg
      }
    },
    componentClass (comp) {
      return ['component', 'component-' + comp.type]
    },
    componentContentStyle (comp) {
      return {
        textAlign: comp.textalign
      }
    },
    componentContentClass (comp) {
      const defaultAlign = {
        paragraph: 'inline',
        subtitle: 'inline',
        quote: 'inline',
        tweet: 'inline',
        fbpost: 'inline',
        pullout: 'inline',
        bullets: 'inline',
        photo: 'spread',
        videocontent: 'spread',
        svgfolder: 'container',
        photogrid: 'container',
        scrolly: 'container',
        iframeresize: 'container',
        datawrapper: 'inline',
        author: 'inline'
      }

      const align = comp.align || defaultAlign[comp.type]
      return {
        'component-content': true,
        [align]: align,
        [comp.class]: comp.class
      }
    },
    url () {
      return window.location.href.replace(/\?.+$/, '')
    }
  }
}
</script>

<style lang="scss">
.component.component-paragraph { // paragraph
  & + .component.component-subtitle {
    margin-top: 20px;
  }

  & + .component:not(.component-subtitle):not(.component-paragraph) {
    margin-top: 20px;
  }
}

// .component.component-subtitle { // subheading h2/h3/h4
//   & + .component:not(.component-subtitle):not(.component-paragraph) {
//     // margin-top: -10px;
//   }
// }

.component:not(.component-subtitle):not(.component-paragraph) { // other component

  & + .component:not(.component-subtitle):not(.component-paragraph) {
    margin-top: 20px;
  }

  & + .component.component-paragraph,
  & + .component.component-subtitle {
    margin-top: 20px;
  }
}

.component {
  // padding-top: 20px;
  // padding-bottom: 20px;
  // padding: 10px $outerSpacing;
  padding: 10px $outerSpacingMobile;

  @include breakpoint($d_medium) {
    padding: 10px $outerSpacing;
  }

  .component-content {
    margin: 0 auto;
    text-align: center;

    & > * {
      display: inline-block;
      vertical-align: bottom;
      width: 100%;
      text-align: left;
    }
  }

  &.component-photo,
  &.component-svgfolder,
  &.component-scrolly,
  &.component-videocontent {
    padding: 10px 0;
  }

  &.component-photogrid {
    padding: 10px 0;

    @include breakpoint($d_medium) {
      padding: 10px $outerSpacing;
    }
  }
}

article > section {
  padding: 0 0 20px;

  &:first-child {
    .component:first-child {
      padding-top: 35px;

      @include breakpoint($d_medium) {
        padding-top: 30px;
      }
    }
  }

  .component {
    .component-content {
      &.spread {
        max-width: 700px;

        @include breakpoint($d_normal) {
          padding: 0 10px;
          max-width: 860px;
        }
      }

      &.inline {
        max-width: 700px;
      }

      &.fullwidth {
        max-width: none;
      }

      &.container {
        max-width: 1200px;
      }

      &.immersive {
        padding: 0;
      }
    }
  }
}
</style>
